module.exports = __webpack_public_path__ + "img/8607047.jpg";